import * as yup from 'yup';
export const commonStaffAndVesselCodeMaintenanceValidation: { [x: string]: any; } = {
  staffCode: yup.string().required("Missing."),
  billingType: yup.string().required("Missing."),
};
export const createStaffAndVesselCodeMaintenanceValidation: { [x: string]: any; } = {
  ...commonStaffAndVesselCodeMaintenanceValidation,
};
export const createStaffAndVesselCodeMaintenanceValidationSchema = yup.object().shape(createStaffAndVesselCodeMaintenanceValidation); 
